import { ReactComponent as searchIcon } from '../../../../../../icons/search.svg';
import React, { useContext, useState } from "react";
import './searchPublicationModal.scss';
import Modal from "../../../../../../components/modalWindow/modal";
import ButtonField from '../../../../../../components/buttonField/buttonField';
import { classNameBtn } from '../../../../../../components/shared/button/types/buttonProps';
import { ButtonFieldProps } from '../../../../../../components/buttonField/types/buttonFieldProps';
import { stylizationVerticalAlign } from '../../../../../../components/shared/stylization';
import { apiContext } from '../../../../../../contexts/apiContext';
import { notifyError, notifyWarn } from '../../../../../../components/snackbar/snackbar';
import { FormFieldProps } from '../../../../../../components/formField/types/formFieldProps';
import FormField from '../../../../../../components/formField/formField';
import { CellContext, createColumnHelper } from '@tanstack/react-table';
import TableActions from '../../../../../../components/shared/table/tableActions/tableActions';
import { TableProps } from '../../../../../../components/shared/table/types/tableProps';
import { HeadersTable } from '../../../../../../helpers/featureTableConstruct';
import Table from '../../../../../../components/shared/table/table';
import ConfirmModal from '../../../../../../components/modalWindow/confirmModal';
import Spinner from '../../../../../../components/spinner/spinner';
import { ClassNameSpinner } from '../../../../../../components/spinner/types/spinnerProps';
import { PublicationsAttributes } from '../../../../../../contexts/krFormContext';
import { QueryPublicationsProps } from '../../../../../../services/registrationCardService/types/registrationCardServiceProps';
import { queryPublications } from '../../../../../../services/registrationCardService/registrationCardService';
import { SearchPublicationModalProps } from './types/searchPublicationModalProps';

const SearchPublicationModal = (props: SearchPublicationModalProps) => {
    const api = useContext(apiContext);
    const [loading, setLoading] = useState<Boolean>(false);
    const [searchFilters, setSearchFilters] = useState<any |null>({
        AUTORZY: "",
        PUBLIKACJA_SOPO: "",
        ROK_POWSTANIA: ""
    });
    const [searchResult, setSearchResult] = useState<any>([]);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [publicationRow, setPublicationRow] = useState<PublicationsAttributes>();
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }

    // Search inputs
    const getInputProps = (labelName: string, inputPlaceholder: string, inputId: string, value?: string | number | null): FormFieldProps => {
        return {
            labelName: labelName,
            inputPlaceholder: inputPlaceholder,
            type: "text",
            pristine: true,
            keepPristine: true,
            setValue: (event: any) => onChangeInput(event, inputId),
            value: value === null ? "" : value
        };
    }

    const onChangeInput = (event: any, id: any) => {       
        setSearchFilters((prevData: any) => ({...prevData, [id]: event}));
    }

    // Search button
    const getBtnProps = (title: string, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium searchBtn`
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            wrapperProps: {
                className: "searchBtnField"
            }
        };
    }
 
    // Publications search table
    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"search-documents-publications"}
            addClickHandler={handleAddClick}
        />)
    }

    const handleAddClick = (row: any) => {
        setPublicationRow(row);
        setConfirmation(true);       
    }

    let headers = {
        autorzy: "Autorzy", 
        publikacjA_SOPO: "Tytuł",         
        roK_POWSTANIA: "Rok", 
    };
    var tableProps: TableProps = {
        columnAliases: headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: Object.keys(headers),
        cellActions: cellAction,
        data: searchResult,
        loading: false,
        className: "table",
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    const searchPublication = () => {
        if (!searchFilters || (!searchFilters.AUTORZY && !searchFilters.PUBLIKACJA_SOPO && !searchFilters.ROK_POWSTANIA)) {
            notifyError({ message: "Uzupełnij przynajmniej jedno pole wyszukiwania" });
        }
        else {
            setLoading(true);
            let queryPublicationsProps: QueryPublicationsProps = {
                landslidePublications: searchFilters,
                apiBase: api.apiUrl + api.apiVersion
            }
    
            queryPublications(queryPublicationsProps)
            .then((response: any) => {
                if (response) {
                    response.sort((a: any, b: any) => {
                        const aYear = a.roK_POWSTANIA !== null && a.roK_POWSTANIA !== undefined ? a.roK_POWSTANIA : -1;
                        const bYear = b.roK_POWSTANIA !== null && b.roK_POWSTANIA !== undefined ? b.roK_POWSTANIA : -1;
                        return bYear - aYear;
                    });
                }
                setSearchResult(response);
                setLoading(false);
                if (response.length === 0) {
                    notifyWarn({ message: "Brak podanych wartości w słowniku publikacji"});
                }
            })
            .catch(() => {
                setLoading(false);
                notifyError({ message: "Wyszukanie publikacji zakończone niepowodzeniem" });
            });
        }
    }

    const confirm = () => {
        setConfirmation(false);
        props.onAddPublication(publicationRow);
        close();
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz dodać publikację ${publicationRow?.publikacjA_SOPO}?`;
    }

    const close = () => {
        props.onClose();
        refocusToMainFormBtn();
    }

    const refocusToMainFormBtn = () => {
        if (props.refocus) props.refocus();
    }
    
    return (<Modal
        title={"Szukaj publikacji"}
        titleIcon={searchIcon}
        iconClass='titleIcon'
        width={'1075px'}
        height={'500px'}
        onClose={close}>
        <div className='searchPublicationModalBody'>
            <div className='searchContainer'>   
                <FormField {...getInputProps("Autor", "Wpisz imię i nazwisko autora", "AUTORZY", searchFilters.AUTORZY)}/>
                <FormField {...getInputProps("Tytuł", "Wpisz tytuł publikacji", "PUBLIKACJA_SOPO", searchFilters.PUBLIKACJA_SOPO)}/>
                <FormField {...getInputProps("Rok", "Wpisz rok powstania publikacji", "ROK_POWSTANIA", searchFilters.ROK_POWSTANIA)}/>
                <ButtonField {...getBtnProps("Szukaj", () => { searchPublication() })}></ButtonField>
            </div>
            <div>
                <Table {...tableProps}/>
            </div>
        </div>
        {confirmation && 
        <ConfirmModal width={"660px"} height={"auto"}
            confirmTitle={"Tak, dodaj publikację"}
            onConfirm={confirm}
            cancelTitle={"Anuluj"}
            onCancel={cancel}
            question={getQuestion()}
            refocus={refocus}
        />}
        {loading && <div className='spinnerSearch'><Spinner spinnerClass={ClassNameSpinner.Big}/></div>}
    </Modal>);
};

export default SearchPublicationModal;